import { render, staticRenderFns } from "./CreateResourcePage.vue?vue&type=template&id=70f112fa&scoped=true"
import script from "./CreateResourcePage.vue?vue&type=script&lang=js"
export * from "./CreateResourcePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f112fa",
  null
  
)

export default component.exports